import authInstance from "../utilities/axios/authInstance";

export const allSecurityLogs = () => authInstance.get('duty-logs/all');